import { mapKeys } from "lodash-es";
import { IToolFacet } from "types";

export const mapFacetSlugToKey = (
  facets: IToolFacet[],
  queryFacets: { [key: string]: string | string[] | null | undefined }
) =>
  mapKeys(
    queryFacets,
    (value, key) => facets.find((facet) => facet.slug === key)?.key
  );
